import request from '../request';

// 获取微信open id
const getWxOpenId = (data) => {
  return request.get(`/api/wx/auth/getOpenId`, data)
}
// 系统语言更改
const changLanguage = function (data) {
  return request.post(`/api/wx/changLanguage`, data)
}

// 开放登录权限
const authLogin = function (data) {
  return request.post('/api/wx/authLogin', data)
}
// 登录
const login = function (data) {
  return request.post('/api/wx/goLoginInfo', data)
}
// 获取验证码
const getVerificationCode = (data) => {
  return request.post('/api/wx/sendSmsCode', data)
}
const findPassword = function (data) {
  return request.post('/api/wx/findPassWord', data)
}
// 对象数组
export default {
  getWxOpenId,
  changLanguage,
  authLogin,
  login,
  getVerificationCode,
  findPassword,
};